import { useNamedContainers } from '@alfa-bank/site-named-container/utils';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from '../styles/styles.css';
import desktopStyles from '../styles/desktop.css';
import type { IDepsDesktop, TMainBannerDesktop } from '../models';

import { MainBannerDesktop as Component } from './main-banner';

export const MainBannerDesktop = createWidget<IDepsDesktop, TMainBannerDesktop>({
    Block,
    Grid,
    Layout,
    styles: { ...styles, ...desktopStyles },
    useNamedContainers,
})(Component);
